/** Shapes + helpers for the piece drawer's video/follows section. */

/** Lifetime video stats per platform (see read-helpers PieceVideoStats). */
export interface PieceVideoStats {
  platform: string;
  avgWatchTimeMs: number | null;
  totalWatchTimeMs: number | null;
  durationSeconds: number | null;
  durationSource: "platform" | "asset" | null;
  pctWatched: number | null;
  replays: number | null;
  retentionCurve: Array<{ second: number; ratio: number }>;
}

/** Sum reported follows; null when no row reported any (render "—", not 0). */
export function sumReportedFollows(rows: Array<{ follows?: string | null }>): number | null {
  let total: number | null = null;
  for (const r of rows) {
    if (r.follows == null) continue;
    const n = Number(r.follows);
    if (!Number.isFinite(n)) continue;
    total = (total ?? 0) + n;
  }
  return total;
}
